<template>
  <v-container class="white elevation-0" grid-list-xl fluid ma-0 pa-0><br>
    <v-layout> 
      <v-toolbar flat color="white">
        <v-toolbar-title class="caption mx-0">Volunteer Management</v-toolbar-title>
          <v-divider class="mx-1" inset vertical></v-divider>
        <v-flex sm2 pt-7>
          <v-text-field outlined dense placeholder="Search" class="caption" prepend-inner-icon="search" v-model="search"></v-text-field>
        </v-flex>
      </v-toolbar>

      <v-flex sm6 xs12 md2>
        <v-card>
           <v-btn depressed medium>
              <v-icon outlined xs-small dark @click.stop="clear()">mdi-close</v-icon>
              <v-icon class="mx-3" fab xs-small dark @click.stop="refresh()">mdi-autorenew</v-icon>
              <v-icon class="mx-3" fab xs-small dark @click.stop="add()">mdi-plus-thick</v-icon>
              <v-icon class="mx-3" fab xs-small dark @click="exportToExcel()">mdi-file-excel</v-icon>
              <v-icon class="mx-3" fab xs-small dark @click.native="print()">mdi-printer</v-icon>
            </v-btn>
				</v-card>
			</v-flex>
    </v-layout>

    <v-data-table dense :headers="headers" :items-per-page="50" v-bind:items="allMemberData" v-bind:search="search" :sort-by="['insertTimeStamp']" :sort-desc="[true, false]" multi-sort item-key="_id" class="caption" :loading="loading">
      <template v-slot:[`item.Edit`]="{ item }">
        <v-avatar size="20" class="brown lighten-1 mx-0"><v-icon small dark @click=getmembershipbyid(item._id)>edit</v-icon></v-avatar>
      </template>
      <template v-slot:[`item.Del`]="{ item }">
        <v-avatar size="20" class="red darken-1 mx-0"><v-icon small dark @click=deleteMember(item._id)>delete</v-icon></v-avatar>
      </template>
    </v-data-table>

    <v-layout row justify-center >
      <v-dialog v-model="popupbox" max-width="800px" hide-overlay>
        <v-toolbar outlined color="light-green lighten-2" height="40">
        <v-toolbar-title class="body-2">Add/Edit Volunteer</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn rounded icon outlined filled small dark color='white' @click="close()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
        <v-form ref="form" v-model="valid" lazy-validation :close-on-content-click="false" :nudge-right="100" offset-y full-width min-width="650px">
          <v-card>
            <v-card-text>
              Primary Details
              <v-divider></v-divider><br>
              <div class="d-flex">
                <v-text-field ref="Json.Name" outlined dense background-color="amber lighten-5" :rules="nameRules" class="caption mr-2" v-model="Json.Name" label="Full Name" placeholder=" " height="25" required></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.Email" outlined dense background-color="amber lighten-5" :rules="nameRules" class="caption mr-2" v-model="Json.Email" label="Primary Email" placeholder=" " height="25" required></v-text-field>
                <v-text-field ref="Json.Mobile" outlined dense background-color="amber lighten-5" class="caption mr-2" v-model="Json.Mobile" label="Mobile" placeholder=" " height="25"></v-text-field>
                <v-select ref="Json.Year" dense background-color="amber lighten-5" required v-model="Json.Year" :items="['2024','2023','2022']" outlined class="caption mr-2"  placeholder=" " label="Year"></v-select>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.Role" outlined dense background-color="amber lighten-5"  class="caption mr-2" v-model="Json.Role" label="Role" placeholder=" " height="25"></v-text-field>
                <v-select ref="Json.Status" dense background-color="amber lighten-5" v-model="Json.Status" :items="['Active', 'Left']" outlined class="caption mr-2"  placeholder=" " label="Status"></v-select>
                <v-text-field ref="Json.Hours" outlined dense background-color="amber lighten-5" class="caption mr-2" v-model="Json.Hours" label="Hours" placeholder=" " height="25"></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.insertTimeStamp" dense background-color="amber lighten-5" required v-model="Json.insertTimeStamp" outlined class="caption mr-2"  placeholder=" " label="insertTimeStamp"></v-text-field>
                <v-text-field ref="Json.updateTimeStamp" dense background-color="amber lighten-5" required v-model="Json.updateTimeStamp" outlined class="caption mr-2"  placeholder=" " label="updateTimeStamp"></v-text-field>
              </div>
              <div class="d-flex">
                <v-text-field ref="Json.Comments" background-color="amber lighten-5" outlined dense class="caption mr-2" v-model="Json.Comments" label="comments" placeholder=" " height="25"></v-text-field>
              </div>
               <v-spacer></v-spacer>
              <v-divider></v-divider><br>             
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline color="light-green lighten-3" @click="close">Close</v-btn>
              <v-btn  v-if="Json._id !== ''" small outline color="light-green lighten-3" @click="update()" :disabled="!valid">Update</v-btn>
              <v-btn  v-if="Json._id === ''" small outline color="light-green lighten-3" @click="submit()" :disabled="!valid">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="popup" persistent max-width="290">
        <v-card>
          <v-card-title class="body-1 blue">Confirmation</v-card-title>
            <v-card-text class="body-1 blue">info would be deleted ?</v-card-text>
              <v-card-actions class="body-1 b">
              <v-btn small outlined color="primary" text flat @click="confirmdelete(id)">Confirm</v-btn>
               <v-spacer></v-spacer><v-btn small outlined color="primary" text flat @click="close()">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

  </v-container>
</template>

<script>
import ReportServices from '@/services/ReportServices'
import XLSX from 'xlsx'

export default {
  data () {
    return {
      allMemberData: [],
      search: '',
      loading: true,
      select: null,
      valid: true,
      nameRules: [v => !!v || 'This Field is required'],
      comment: null,
      popupbox: false,
      popup: false,
      Json: {
        _id: '',
        Name: '',
        Email: '',
        Mobile: '',
        Role: '',
        Year: '',
        Status: '',
        Comments: '',
        Hours: '',
        updateTimeStamp: '',
        insertTimeStamp: ''
      },
        headers: 
            [
            {text: 'NAME', align: 'left', value: 'Name'},
            {text: 'Email', align: 'left', value: 'Email'},
            {text: 'Mobile', align: 'left', value: 'Mobile'},
            {text: 'Year', align: 'left', value: 'Year'},
            {text: 'Role', align: 'left', value: 'Role'},
            {text: 'Status', align: 'left', value: 'Status'},
            {text: 'Comments', align: 'left', value: 'Comments'},
            {text: 'Last Updated', align: 'left', value: 'updateTimeStamp'},
            {text: 'Edit', align: 'left', value: 'Edit'},
            {text: 'Del', align: 'left', value: 'Del'}
        ]
    }
  },
  computed: {
    loggedInUser () {
      var user = this.$store.getters.email
      var role = this.$store.getters.role
      if (user && (role === "SuperAdmin")) return 'SuperAdmin'
      else if (user && (role === "Admin")) return 'Admin'
      else if (user && (role === "Member")) return 'Member'
      else return null
    }
  },
  methods: {
    changeDate(date) {
      var options = {
        timeZone: "America/New_York",
        hour12: "true",
        year: "2-digit",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      };
      return new Date(date).toLocaleTimeString("en-us", options);
    },
    exportToExcel () {
      var membershipdata = XLSX.utils.json_to_sheet(this.allMemberData) 
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, membershipdata, 'volunteerdata')
      XLSX.writeFile(wb, 'volunteerdata.xlsx')
    },
    print () {
      window.print()
    },
    logoutFromFirebase () {
      this.$store.dispatch('signOutAction')
      .then(() => this.$router.replace('/Signin'))
    },
    clear() {
      this.search= ''
      this.Name=''
    },
    async cleardata () {
      this.Json.Name = ''
      this.Json.Email = ''
      this.Json.Mobile = ''
      this.Json.Role = ''
      this.Json.Year = ''
      this.Json.Status = ''
      this.Json.Comments = ''
      this.Json.Hours = ''
      this.Json._id = ''
    },
    async getmembershipbyid (id) {
      if (id) {
        this.popupbox = true
        this.CommentInfo = (await ReportServices.getVolunteerById(id)).data
        this.Json= this.CommentInfo
      }
    },
    async add () {
      this.popupbox = true
      this.cleardata ()
    },
    submit () {
      if (this.$refs.form.validate()) {
        ReportServices.addVolunteerInfo(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 300)
      }
    },
    async update () {
      if (this.$refs.form.validate()) {
        ReportServices.updateVolunteerInfo(this.Json)
        this.popupbox = false
        setTimeout(() => {
          this.refresh()
        }, 300)
      }
    },
    async deleteMember(id) {
      this.id = id
      this.popup = true
    },
    async confirmdelete (id) {
      ReportServices.deleteVolunteerById(id)
       this.popup = false
      setTimeout(() => {
        this.refresh()
      }, 300)
    },
    close () {
      this.popupbox = false
      this.popup = false
    },
    async refresh () {
      this.loading = true
      this.allMemberData = (await ReportServices.getVolunteerInfo()).data
      this.loading = false
      this.noDataText = 'No data available'
    }
  },
  async mounted () {
    this.refresh()
  }
}
</script>